/**
 * EdgeBanner Component - DDIL state banner at top of screen
 * Green (FULL) / Yellow (DEGRADED) / Red (DENIED)
 */

import type { EdgeStatus } from '../../types'

interface EdgeBannerProps {
  edgeStatus: EdgeStatus | null
  onSync: () => void
}

export function EdgeBanner({ edgeStatus, onSync }: EdgeBannerProps) {
  if (!edgeStatus || edgeStatus.connectivity === 'FULL') return null

  const isDenied = edgeStatus.connectivity === 'DENIED'
  const bannerClass = isDenied ? 'edge-banner-denied' : 'edge-banner-degraded'

  const modelsAvailable = Object.entries(edgeStatus.models)
    .filter(([, status]) => status === 'loaded')
    .map(([name]) => name)

  const modelsUnavailable = Object.entries(edgeStatus.models)
    .filter(([, status]) => status !== 'loaded')
    .map(([name]) => name)

  return (
    <div className={`${bannerClass} border-b px-4 py-2 flex items-center justify-between text-xs`}>
      <div className="flex items-center gap-3">
        <span className="font-bold uppercase tracking-wider">
          COMMS {edgeStatus.connectivity}
        </span>
        <span className="opacity-75">|</span>
        <span>DDIL Level {edgeStatus.ddil_level}</span>
        <span className="opacity-75">|</span>
        <span>
          Edge models active: {modelsAvailable.join(', ') || 'None'}
        </span>
        {modelsUnavailable.length > 0 && (
          <>
            <span className="opacity-75">|</span>
            <span className="opacity-75">
              Unavailable: {modelsUnavailable.join(', ')}
            </span>
          </>
        )}
      </div>
      {!isDenied && edgeStatus.sync_pending > 0 && (
        <button
          onClick={onSync}
          className="px-2 py-0.5 border border-current rounded hover:bg-white/10 transition-colors"
        >
          SYNC ({edgeStatus.sync_pending} pending)
        </button>
      )}
    </div>
  )
}
